import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { brand, heroContents, heroFacts, mockups } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section id="top" className="w-full bg-amber-50 pb-16 pt-12 md:pb-20 md:pt-16" data-id="element-92" data-mp="9lbfcytwl7cj">
      <div className="mx-auto w-full max-w-5xl px-5 text-center md:px-8" data-id="element-93" data-mp="4n1kyqg06arz">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="inline-flex items-center gap-2 rounded-full bg-pink-100 px-4 py-2 text-xs font-extrabold uppercase tracking-widest text-pink-700 ring-1 ring-pink-200" data-id="element-94" data-mp="12a0j75mcfqrz">
          <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-95" data-mp="nbop96qcuw4i" />
          {brand.tag}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease
      }} className="mx-auto mt-6 max-w-4xl text-4xl font-extrabold leading-none tracking-tight text-neutral-800 sm:text-5xl md:text-6xl" data-id="element-96" data-mp="3d33f4zea6vla">
          Transformez votre action Octobre Rose en{' '}
          <span className="bg-pink-200 px-1.5 pb-0.5 leading-tight text-pink-950" data-id="element-97" data-mp="39b4fyxmj3o1c">
            un moment qui sensibilise, crée du lien et marque les esprits
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease
      }} className="mx-auto mt-6 max-w-3xl text-xl font-bold leading-snug text-neutral-600 md:text-2xl" data-id="element-98" data-mp="30hrgtdxvfq6t">
          Un kit d’animation 3-en-1 avec 50 cartes de réflexion, 150 marque-pages inspirants et un
          guide d’animation de 50 pages, prêts à imprimer et à utiliser.
        </motion.p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.14,
        ease
      }} src={mockups.kit} alt="Kit d’Animation Octobre Rose 3-en-1 : 50 cartes de réflexion, 150 marque-pages inspirants, guide d’animation de 50 pages et 3 bonus" className="mx-auto mt-10 w-full max-w-3xl rounded-3xl shadow-xl" width={1024} height={1024} data-id="element-99" data-mp="2hljb690y5daz" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease
      }} className="mx-auto mt-11 max-w-3xl" data-id="element-100" data-mp="db2cf8kas3k3">
          <p className="mx-auto max-w-2xl text-lg leading-relaxed text-neutral-500" data-id="element-101" data-mp="112pvx5f8cccc">
            Tout ce qu’il vous faut pour préparer une animation Octobre Rose plus humaine,
            participative et structurée, sans partir d’une page blanche.
          </p>

          <ul className="mt-9 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm font-extrabold uppercase tracking-wide text-pink-900" data-id="element-102" data-mp="3lui9cqv5izld">
            {heroContents.map((item, index) => <li key={item} className="inline-flex items-center gap-3" data-id="element-103" data-mp="1xb5pse406rg4" data-mpi={index}>
                {index > 0 && <span className="h-1 w-1 rounded-full bg-amber-400" aria-hidden="true" data-id="element-104" data-mp="218to7r4wn2cr" />}
                {item}
              </li>)}
          </ul>

          <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm font-semibold text-neutral-500" data-id="element-105" data-mp="2b1hh4asrkm67">
            {heroFacts.map((fact, index) => <li key={fact} className="inline-flex items-center gap-3" data-id="element-106" data-mp="2ky40sw9ct76n" data-mpi={index}>
                {index > 0 && <span className="h-1 w-1 rounded-full bg-amber-400" aria-hidden="true" data-id="element-107" data-mp="2p1jv3lxyavg6" />}
                {fact}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}